// Puantaj durumları ve maaş hesabı.
//
// Bu dosya backend/routes/hr.py içindeki _puantaj_hesapla ile AYNI kuralı
// uygular. Ekranda anlık hesap gerektiği için formül iki yerde duruyor;
// para yazan uçlar (onay ve tahakkuk) sunucudaki hesabı kullanır, buradaki
// yalnızca gösterimdir. İkisi ayrışırsa ekran ile tahakkuk farklı rakam
// gösterir — bu dosyada bir şey değiştirirken hr.py de değişmeli.


export const PUANTAJ_VARSAYILAN = {
  resmi_tatil_katsayi: 2,        // RTÇ işaretli gün kaç gün sayılsın
  mesai_katsayi: 1.5,            // fazla mesai saatinin zam katsayısı
  gunluk_calisma_saati: 7.5,     // saatlik ücret = günlük ücret / bu
  // Raporlu gün ücretli mi (hr.py PUANTAJ_BOOL ile aynı varsayılan: ücretli)
  rapor_ucretli: true,
};

export const DURUMLAR = [
  { deger: 'worked', etiket: 'Çalıştı', kod: 'Ç', sinif: 'bg-green-500' },
  { deger: 'weekly_leave', etiket: 'Haftalık İzin', kod: 'Hİ', sinif: 'bg-blue-400' },
  { deger: 'annual_leave', etiket: 'Yıllık İzin', kod: 'Yİ', sinif: 'bg-purple-400' },
  { deger: 'unpaid_leave', etiket: 'Ücretsiz İzin', kod: 'Üİ', sinif: 'bg-orange-400' },
  { deger: 'absent', etiket: 'Devamsızlık', kod: 'D', sinif: 'bg-red-500' },
  { deger: 'public_holiday', etiket: 'Resmi Tatil', kod: 'RT', sinif: 'bg-cyan-400' },
  { deger: 'public_holiday_worked', etiket: 'Resmi Tatil Çalışması', kod: 'RTÇ', sinif: 'bg-cyan-700' },
  { deger: 'sick_leave', etiket: 'Rapor', kod: 'R', sinif: 'bg-rose-400' },
  { deger: 'excuse_leave', etiket: 'Mazeret İzni', kod: 'Mİ', sinif: 'bg-fuchsia-500' },
];

export const DURUM_SINIF = Object.fromEntries(DURUMLAR.map(d => [d.deger, d.sinif]));

// ─── HİZMET DÖNEMLERİ ───
// `hr.py` → `_donemler` / `_kadroda_mi` ile AYNI kural. Ayrılıp geri dönen
// personelde `hire_date` İLK giriştir ve `termination_date` son dönem açıksa
// BOŞTUR; yalnızca bu ikisine bakan kod iki dönem ARASINDAKİ boşluğu göremez
// ve o günleri "çalıştı" sayar (Carmel Kiriza, 2026-09-21).
export const donemleri = (emp) => {
  const ham = emp?.donemler;
  if (Array.isArray(ham) && ham.length) return ham.filter(d => d?.giris);
  if (!emp?.hire_date) return [];
  return [{ giris: emp.hire_date, cikis: emp.termination_date || null }];
};

// O gün HERHANGİ bir hizmet döneminin içinde mi?
// İşe giriş tarihi BOŞSA `true` döner: girişi eksik personelin maaşı sessizce
// sıfırlanmasın (hr.py `_etkin_gunler` ile aynı tercih).
export const kadrodaMi = (emp, isoTarih) => {
  const donemler = donemleri(emp);
  if (!donemler.length) return true;
  return donemler.some(d => {
    const g = String(d.giris || '9999-99-99').slice(0, 10);
    const c = String(d.cikis || '').slice(0, 10);
    return g <= isoTarih && !(c && c < isoTarih);
  });
};

export const isoGun = (yil, ay, gun) =>
  `${yil}-${String(ay).padStart(2, '0')}-${String(gun).padStart(2, '0')}`;
export const DURUM_KOD = Object.fromEntries(DURUMLAR.map(d => [d.deger, d.kod]));
export const DURUM_ETIKET = Object.fromEntries(DURUMLAR.map(d => [d.deger, d.etiket]));

// Haftalık izin, kullanıcının kararıyla "1 gün çalıştı" sayılır.
const CALISILAN_SAYILAN = ['worked', 'weekly_leave', 'public_holiday_worked'];
// Haftada en az bir gun dinlenme (4857 md. 46): bir takvim haftasinda FIILEN
// calisilan gun 6'yi asiyorsa asan kisim kullanilmayan haftalik izindir.
// Sunucudaki FIILEN_CALISILAN / _kullanilmayan_hafta_tatili ile birebir ayni.
const FIILEN_CALISILAN = ['worked', 'public_holiday_worked'];
const HAFTALIK_AZAMI_CALISMA = 6;

function isoHafta(yil, ay, gun) {
  const d = new Date(Date.UTC(yil, ay - 1, gun));
  const gunNo = d.getUTCDay() || 7;             // Pazar = 7
  d.setUTCDate(d.getUTCDate() + 4 - gunNo);     // haftanin persembesi
  const yilBasi = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const hafta = Math.ceil(((d - yilBasi) / 86400000 + 1) / 7);
  return `${d.getUTCFullYear()}-${hafta}`;
}
const UCRETLI_IZIN = ['annual_leave', 'public_holiday', 'excuse_leave'];

export function sayi(ham, varsayilan = 0) {
  const v = parseFloat(String(ham ?? '').replace(',', '.'));
  return Number.isFinite(v) ? v : varsayilan;
}

export function ayarlariBirlestir(gelen) {
  const a = { ...PUANTAJ_VARSAYILAN };
  for (const k of ['resmi_tatil_katsayi', 'mesai_katsayi', 'gunluk_calisma_saati']) {
    const v = sayi(gelen?.[k], 0);
    if (v > 0) a[k] = v;
  }
  if (typeof gelen?.rapor_ucretli === 'boolean') a.rapor_ucretli = gelen.rapor_ucretli;
  return a;
}

// İlave hakta "çalışılan gün": her türlü izin ve resmi tatil HARİÇ (hr.py HAK_CALISILAN)
const HAK_CALISILAN = ['worked', 'public_holiday_worked'];

/**
 * Bir ilave hakkın o ayki tutarı — hr.py `_ilave_hak_hesapla` ile AYNI kural.
 *   gunluk: tutar günlük, yalnızca çalışılan günler ödenir.
 *   aylik:  tutar aylık; devamsızlık yoksa tam, varsa 30 üzerinden ödenen gün.
 * Devamsızlık ve kadro dışı günler hiçbir hak için ödenmez (`durumCoz` kadro
 * dışını 'absent' döndürür).
 */
export function ilaveHakHesapla({ hak, durumCoz, gunSayisi }) {
  const tutar = sayi(hak?.tutar);
  let odenen = 0;
  let toplam;
  if (hak?.hesaplama === 'gunluk') {
    for (let g = 1; g <= gunSayisi; g++) if (HAK_CALISILAN.includes(durumCoz(g))) odenen++;
    toplam = tutar * odenen;
  } else {
    for (let g = 1; g <= gunSayisi; g++) if (durumCoz(g) !== 'absent') odenen++;
    toplam = odenen === gunSayisi ? tutar : (tutar / 30) * Math.min(odenen, 30);
  }
  return { tutar: Math.round(toplam * 100) / 100, odenen_gun: odenen };
}

/**
 * Bir personelin bir aylık puantajından maaşını çıkarır.
 * Denkleştirme 2026-09-18'de kaldırıldı: RTÇ fazlası ve fazla mesai HER ZAMAN
 * ücrete gider. Sunucudaki `_puantaj_hesapla` ile birebir aynı kalmalı.
 * @param gunler       {'1': 'worked', ...} — eksik günler 'worked' sayılır
 * @param mesaiGunleri {'1': 2.5, ...} saat
 * @param durumCoz     (gun) => durum — işe giriş/çıkış dışını 'absent' yapmak için
 */
export function hesapla({ gunler = {}, mesaiGunleri = {}, aylikMaas = 0,
                          employmentType = 'full_time', gunSayisi = 30,
                          ayar = PUANTAJ_VARSAYILAN, durumCoz = null,
                          yil = null, ay = null, girilmisMi = null }) {
  const gunluk = aylikMaas ? aylikMaas / 30 : 0;
  const saatlik = gunluk ? gunluk / ayar.gunluk_calisma_saati : 0;

  let calisilan = 0, ucretliIzin = 0, ucretsiz = 0, devamsiz = 0, rtc = 0, rapor = 0;
  let tatilFazlasi = 0, mesaiSaat = 0, eksikSaat = 0;

  for (let gun = 1; gun <= gunSayisi; gun++) {
    const durum = durumCoz ? durumCoz(gun) : (gunler[String(gun)] ?? 'worked');

    if (CALISILAN_SAYILAN.includes(durum)) {
      calisilan++;
      if (durum === 'public_holiday_worked') {
        rtc++;
        tatilFazlasi += Math.max(0, ayar.resmi_tatil_katsayi - 1);
      }
    } else if (UCRETLI_IZIN.includes(durum) || (durum === 'sick_leave' && ayar.rapor_ucretli !== false)) {
      ucretliIzin++;
      if (durum === 'sick_leave') rapor++;
    } else if (durum === 'unpaid_leave' || durum === 'sick_leave') {
      ucretsiz++;
      if (durum === 'sick_leave') rapor++;
    }
    else if (durum === 'absent') devamsiz++;

    // Mesai alani IKI YONLU: pozitif fazla mesai, negatif EKSIK calisma
    const saat = sayi(mesaiGunleri[String(gun)]);
    if (saat > 0) mesaiSaat += saat;
    else if (saat < 0) eksikSaat += -saat;
  }

  // Kullanilmayan haftalik izin: ayri kalem degil, gunluk saat kadar mesai
  let haftaTatiliGun = 0;
  if (yil && ay) {
    const haftalar = {};
    for (let gun = 1; gun <= gunSayisi; gun++) {
      // Sadece ACIKCA girilmis gunler (bos gun otomatik hafta tatili borcu
      // dogurmasin); sunucudaki _kullanilmayan_hafta_tatili ile ayni kural
      if (girilmisMi && !girilmisMi(gun)) continue;
      const durum = durumCoz ? durumCoz(gun) : gunler[String(gun)];
      if (!FIILEN_CALISILAN.includes(durum)) continue;
      const h = isoHafta(yil, ay, gun);
      haftalar[h] = (haftalar[h] || 0) + 1;
    }
    haftaTatiliGun = Object.values(haftalar)
      .reduce((t, n) => t + Math.max(0, n - HAFTALIK_AZAMI_CALISMA), 0);
    if (haftaTatiliGun) mesaiSaat += haftaTatiliGun * ayar.gunluk_calisma_saati;
  }

  const bazGun = Math.min(calisilan + ucretliIzin, 30);
  const tamZamanli = employmentType === 'full_time';
  const bazUcret = (tamZamanli && ucretsiz === 0 && devamsiz === 0) ? aylikMaas : bazGun * gunluk;
  const tatilUcreti = tatilFazlasi * gunluk;
  const mesaiUcreti = mesaiSaat * saatlik * ayar.mesai_katsayi;
  // Eksik calisma KATSAYISIZ dusulur (bkz. hr.py _puantaj_hesapla)
  const eksikKesinti = eksikSaat * saatlik;
  const yuvarla = (n) => Math.round(n * 100) / 100;

  return {
    monthly_salary: aylikMaas,
    daily_rate: yuvarla(gunluk),
    hourly_rate: yuvarla(saatlik),
    worked_days: calisilan,
    paid_leave_days: ucretliIzin,
    unpaid_days: ucretsiz,
    absent_days: devamsiz,
    holiday_work_days: rtc,
    holiday_extra_days: yuvarla(tatilFazlasi),
    overtime_hours: yuvarla(mesaiSaat),
    overtime_paid_hours: yuvarla(mesaiSaat),
    missing_hours: yuvarla(eksikSaat),
    unused_weekly_rest_days: haftaTatiliGun,
    missing_deduction: yuvarla(eksikKesinti),
    sick_days: rapor,
    base_pay: yuvarla(bazUcret),
    holiday_pay: yuvarla(tatilUcreti),
    overtime_pay: yuvarla(mesaiUcreti),
    // Fazla calismanin TOPLAMI, ham degerlerden TEK seferde yuvarlanir
    // (bkz. hr.py `_puantaj_hesapla`): `holiday_pay + overtime_pay` toplamak
    // iki yuvarlamayi ust uste bindirip tahakkuktaki maas satirini bir kurus
    // kaydiriyordu (55.000,00 yerine 54.999,99).
    extra_work_pay: yuvarla(tatilUcreti + mesaiUcreti),
    // Maas satirinin CAPASI — artik mesai tarafinda kalsin (bkz. hr.py)
    salary_pay: yuvarla(bazUcret - eksikKesinti),
    deduction: tamZamanli ? yuvarla(aylikMaas - bazUcret) : 0,
    net_salary: yuvarla(bazUcret + tatilUcreti + mesaiUcreti - eksikKesinti),
    employment_type: employmentType,
  };
}
